import React from 'react';
import { motion } from 'framer-motion';
import Stamp from '../components/Stamp';

const About = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="font-mono text-[0.7rem] tracking-[0.25em] uppercase text-teal mb-4">
            About Synema
          </div>
          <h1 className="font-display text-[clamp(2.5rem,5vw,4rem)] tracking-[0.04em] leading-none text-white mb-6">
            Cinema was always meant to be shared.
          </h1>
          <p className="text-[1rem] font-light leading-[1.8] text-white/[0.65] max-w-[640px]">
            Synema Interactive Film Festival is the world's first communal streaming film festival — built on Mindi.TV, where audiences watch together in real time, react together, and connect directly with the filmmakers behind the work.
          </p>
        </motion.div>

        {/* Mission */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">OUR MISSION</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <p className="text-[0.95rem] font-light text-white/60 leading-[1.8]">
              Film festivals were invented to bring people together around cinema. But somewhere along the way, they became gatekept by geography, economics, and access. If you're not in the right city, you're not in the room.
            </p>
            <p className="text-[0.95rem] font-light text-white/60 leading-[1.8]">
              Synema changes that. We bring the festival experience to everyone — no flights, no hotel rooms, no waiting lists. Just cinema, shared globally, in real time. Your film doesn't screen to 200 people in one city — it screens to thousands worldwide, simultaneously, in a watch party.
            </p>
          </div>
        </motion.div>

        {/* Platform Story */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">THE PLATFORM</h2>
          <div className="bg-dark2 border border-white/[0.06] rounded p-8">
            <p className="text-[0.95rem] font-light text-white/60 leading-[1.8] mb-4">
              Synema is built on <a href="https://mindi.tv" target="_blank" rel="noopener noreferrer" className="text-teal font-medium">Mindi.TV</a> — a next-generation streaming platform designed for communal viewing experiences. Mindi.TV enables synchronized watch parties, real-time audience reactions, live Q&As, and interactive advertising formats like group buying units.
            </p>
            <p className="text-[0.95rem] font-light text-white/60 leading-[1.8]">
              Every screening at Synema happens as a live, synchronized event. Thousands of viewers watch the same film at the same moment, react together, and engage with filmmakers in real time. It's the full festival experience, rebuilt for everywhere.
            </p>
            <div className="mt-6">
              <Stamp />
            </div>
          </div>
        </motion.div>

        {/* Mindi.TV Relationship */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">MINDI.TV</h2>
          <p className="text-[0.95rem] font-light text-white/60 leading-[1.8] max-w-[640px]">
            Mindi.TV is the streaming platform that powers Synema. It's built for communal experiences — synchronized playback, real-time reactions, live engagement data, and interactive ad formats. Synema is the flagship festival on the platform, but Mindi.TV's technology enables any creator or brand to build shared viewing experiences at scale.
          </p>
        </motion.div>

        {/* Team Placeholder */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display text-2xl tracking-[0.05em] text-white mb-6">THE TEAM</h2>
          <div className="bg-dark2 border border-white/[0.06] rounded p-10 text-center">
            <p className="text-[0.95rem] font-light text-white/50 leading-relaxed">
              Team bios and photos coming soon. Synema is built by filmmakers, technologists, and community builders who believe cinema is better when it's shared.
            </p>
            <p className="mt-4 text-[0.8rem] text-muted">
              Interested in joining the team? Email{' '}
              <a href="mailto:synemafest@gmail.com" className="text-teal font-medium">synemafest@gmail.com</a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
